import { detailRoutes } from "./detailRoutes";
import { AppState } from "./model";
import { workGroupSelector } from "./selectors";

const detailRoute = () => ({
    "/:workGroupId": {
        title: (state: AppState) => workGroupSelector(state).name || "Work Group",
        "/edit": {
            title: "Edit"
        },
        ...detailRoutes
    }
});

export const routes = {
    "/workGroups": {
        title: "WorkGroups",
        ...detailRoute(),
        "/create": {
            title: "Create Work Group"
        }
    }
};

export const childRoutes = (titleFunc: (state: any) => string) => {
    return {
        "/workGroups": {
            title: (state: AppState) => titleFunc(state) ? titleFunc(state) + " Work Groups" : "Work Groups",
            ...detailRoute(),
            "/create": {
                title: "Create Work Group",
            }
        }
    };
};
